var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconNoAccounts(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 106,
    viewBox: "0 0 120 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    clipPath: "url(#clip0_3090_13378)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M40.2151 13.0584L39.9318 13.6309C38.0765 17.3849 34.256 19.7602 30.075 19.7602H10.9991C4.92447 19.7595 0 24.6925 0 30.7776V71.2576C0 77.3428 4.92447 82.2758 10.9991 82.2758H80.2625C86.3372 82.2758 91.2616 77.3428 91.2616 71.2576V17.948C91.2616 11.8628 86.3372 6.92981 80.2625 6.92981H50.0727C45.8909 6.92981 42.0711 9.30511 40.2158 13.0591L40.2151 13.0584Z",
    fill: "#FEF267"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14.2423 86.2553L4.08057 79.8213H33.8781V86.2553H14.2423Z",
    fill: "#FEF267"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M8.9523 0H87.379C90.0673 0 92.2507 2.18641 92.2507 4.88015V69.6581C92.2507 72.3511 90.0681 74.5383 87.379 74.5383H8.9523C6.26392 74.5383 4.08057 72.3519 4.08057 69.6581V4.88015C4.08057 2.18641 6.2632 0 8.9523 0Z",
    fill: "#FFF8B3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M49.4983 18.8482L49.215 19.4207C47.3597 23.1747 43.5399 25.55 39.3582 25.55H20.2823C14.2077 25.55 9.2832 30.483 9.2832 36.5681V77.0481C9.2832 83.1333 14.2077 88.0663 20.2823 88.0663H89.5457C95.6204 88.0663 100.545 83.1333 100.545 77.0481V23.7378C100.545 17.6526 95.6204 12.7196 89.5457 12.7196H59.3559C55.1741 12.7196 51.3543 15.0949 49.499 18.8489L49.4983 18.8482Z",
    fill: "#FEF267"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M89.6624 105.383C106.417 105.383 120 91.7769 120 74.9932C120 58.2094 106.417 44.6035 89.6624 44.6035C72.9076 44.6035 59.3252 58.2094 59.3252 74.9932C59.3252 91.7769 72.9076 105.383 89.6624 105.383Z",
    fill: "#CC0D0E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M96.5925 74.9932L104.614 66.9583C105.797 65.7728 105.797 63.8513 104.614 62.6665L101.968 60.0162C100.784 58.8307 98.8662 58.8307 97.6835 60.0162L89.6625 68.0511L81.6414 60.0162C80.458 58.8307 78.5398 58.8307 77.3571 60.0162L74.7113 62.6665C73.5279 63.852 73.5279 65.7735 74.7113 66.9583L82.7324 74.9932L74.7113 83.0281C73.5279 84.2136 73.5279 86.1351 74.7113 87.3198L77.3571 89.9702C78.5405 91.1556 80.4587 91.1556 81.6414 89.9702L89.6625 81.9352L97.6835 89.9702C98.8669 91.1556 100.785 91.1556 101.968 89.9702L104.614 87.3198C105.797 86.1344 105.797 84.2128 104.614 83.0281L96.5925 74.9932Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3090_13378"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 105.382,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNoAccounts);
export default __webpack_public_path__ + "static/media/icon_no_accounts.50913b746c47bb112d077801516a9dd0.svg";
export { ForwardRef as ReactComponent };